import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  QuestionOutlined
} from '@ant-design/icons'
import { Button, Divider, Flex, Layout } from 'antd'

import { NotificationPopover, ProfileCard, QRButton, RoleChanger } from '..'

import { useStyles } from './styles'

type Props = {
  onToggle: () => void
  isCollapsed: boolean
}

export const Header = ({ onToggle, isCollapsed }: Props) => {
  const { styles } = useStyles()

  return (
    <Layout.Header className={styles.header}>
      <Flex gap={8} align="center">
        <Button
          onClick={onToggle}
          type="text"
          icon={isCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        />
      </Flex>

      <Flex align="center" gap={16}>
        <Flex gap={8}>
          <Button icon={<QuestionOutlined />} />
          <QRButton />
          <NotificationPopover />
        </Flex>
        <Divider type="vertical" className={styles.divider} />
        <ProfileCard />
        <Divider type="vertical" className={styles.divider} />
        <RoleChanger />
      </Flex>
    </Layout.Header>
  )
}
